var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisplayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.708252 6.37498C0.708252 3.70368 0.708252 2.36804 1.53812 1.53818C2.36798 0.708313 3.70362 0.708313 6.37492 0.708313H13.9305C16.6017 0.708313 17.9374 0.708313 18.7673 1.53818C19.5971 2.36804 19.5971 3.70368 19.5971 6.37498V7.31942C19.5971 9.99069 19.5971 11.3263 18.7673 12.1562C17.9374 12.9861 16.6017 12.9861 13.9305 12.9861H6.37492C3.70362 12.9861 2.36798 12.9861 1.53812 12.1562C0.708252 11.3263 0.708252 9.99069 0.708252 7.31942V6.37498Z",
    stroke: "#4D5874",
    strokeWidth: 1.41667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1528 15.8194V13.4583M10.1528 15.8194L15.8194 17.7083M10.1528 15.8194L4.48608 17.7083",
    stroke: "#4D5874",
    strokeWidth: 1.41667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayIcon);
export default __webpack_public_path__ + "static/media/display_icon.b7ea962dea6bd6aa2d3c9188eef13e36.svg";
export { ForwardRef as ReactComponent };